module.exports = __webpack_public_path__ + "static/media/Profileimage.49fdde9a.svg";